import { defineNuxtPlugin } from '#app'
import {
  flushFrontendErrorLogQueue,
  initializeFrontendErrorLog,
  reportFrontendHandledError,
  syncFrontendErrorRoute,
} from '@/utils/frontendErrorLog'

export default defineNuxtPlugin((nuxtApp) => {
  initializeFrontendErrorLog()

  const router = nuxtApp.$router
  const reportedErrors = new WeakSet()
  const reportFrameworkError = (error, source, extraContext = {}) => {
    if (error && typeof error === 'object') {
      if (reportedErrors.has(error))
        return
      reportedErrors.add(error)
    }
    reportFrontendHandledError({
      errorType: 'js_runtime',
      errorCode: 'VUE_RUNTIME',
      errorName: error?.name || 'VueError',
      message: error,
      stack: error?.stack,
      rawContext: { source, ...extraContext },
    })
  }

  const syncRoute = (route) => {
    syncFrontendErrorRoute({
      routeName: route?.name ? String(route.name) : null,
      routePath:
        route?.fullPath
        || `${window.location.pathname || ''}${window.location.search || ''}`,
    })
  }

  syncRoute(router.currentRoute.value)
  router.afterEach(to => syncRoute(to))

  nuxtApp.hook('vue:error', (error, _instance, info) => {
    reportFrameworkError(error, 'vue:error', { info })
  })
  nuxtApp.hook('app:error', (error) => {
    reportFrameworkError(error, 'app:error')
  })

  return {
    provide: {
      frontendErrorLog: {
        report: reportFrontendHandledError,
        flush: flushFrontendErrorLogQueue,
      },
    },
  }
})
